// Apollo
import { apolloClient } from '@/graphql';
import gql from 'graphql-tag';

// GraphQL
import UpdateCountry from '@/graphql/countries/update/updateCountry.gql';
import InsertCountries from '@/graphql/countries/insert/insertCountries.gql';
import DeleteCountry from '@/graphql/countries/delete/deleteCountry.gql';

export default {
	state: {
		countries: [] as Country[],
	},

	// ================ Getters ================
	getters: {
		countries(state: any) {
			return state.countries;
		},
	},

	// ================ Mutations ================
	mutations: {
		setCountries(state: any, countries: any) {
			state.countries = countries;
		},
	},

	// ================= Actions =================
	actions: {
		async getCountries({ commit }: any) {
			const response = await apolloClient.query({
				query: gql`
					query countries {
						countries {
							id
							name
							cities {
								id
								name
								locations {
									id
									name
								}
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});
			const { countries } = response.data;
			commit('setCountries', countries);
		},

		async insertCountry({ dispatch }: any, payload: any) {
			const objects = [
				{
					name: payload.name,
				},
			];

			await apolloClient
				.mutate({
					mutation: InsertCountries,
					// Parameters
					variables: {
						objects,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			dispatch('getCountries');
			return;
		},

		async deleteCountry({ dispatch }: any, payload: any) {
			const { id } = payload;
			await apolloClient
				.mutate({
					mutation: DeleteCountry,
					// Parameters
					variables: {
						countryId: id,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			dispatch('getCountries');
			return;
		},

		async updateCountry({ dispatch }: any, payload: any) {
			const { id, name } = payload;
			await apolloClient.mutate({
				mutation: UpdateCountry,
				// Parameters
				variables: {
					countryId: id,
					name,
				},
			});

			dispatch('getCountries');
			return;
		},
	},
};
